import React from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { RestartOmsWorkflowModal as RestartOmsWorkflowModalProps } from '@/types/modal';
import {
  BodyModal,
  CloseFooterModal,
  CustomModal,
  HeadingModal,
} from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const RestartOmsWorkflowModal: React.FC<{ modal: RestartOmsWorkflowModalProps }> = ({ modal }) => {
  const { t } = useTranslation();

  const { onClose } = modal;

  return (
    <CustomModal
      onClose={onClose}
      body={
        <>
          <HeadingModal
            title={t('item.restart_oms_workflow.title')}
            onClose={onClose}
          />

          <BodyModal
            body={
              <div className={clsx([styles.paddingY1rem, styles.shippingReminder_container])}>
                <p>{t('item.restart_oms_workflow.description')}</p>
              </div>
            }
          />

          <CloseFooterModal
            onClose={onClose}
            closeLabel={t('common.ok').toUpperCase()}
          />
        </>
      }
      containerStyle={{ width: 600 }}
      modalName="restartOmsWorkflowModal"
    />
  );
};

export default RestartOmsWorkflowModal;
